<script setup lang="ts">
import { PayoutsEmbed } from '@/Pejer/tables/Payouts'
import { ArrowRight } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'

import { Dialog, DialogContent, DialogTrigger } from 'pejer/src/components/ui/dialog'
import PaymentVoucherContent from 'pejer/src/views/Payouts/PaymentVoucher/PaymentVoucherContent.vue'

const props = defineProps<{
  payoutId: PayoutsEmbed.ListItem['payoutId']
}>()
</script>
<template>
  <Dialog>
    <DialogTrigger as-child>
      <slot>
        <Button
          @click.prevent.stop
          variant="ghost"
          class="p-1 h-6 hover:bg-gray-200 rounded-sm group text-gray-600"
        >
          <ArrowRight class="group-hover:scale-110" :size="16" />
        </Button>
      </slot>
    </DialogTrigger>
    <DialogContent class="max-w-[calc(100vw-20px)] max-h-[calc(100vh-50px)] flex flex-col">
      <!-- <DialogDescription class="flex-1">
        Betalt til bankkontonummer <b>{{ data?.toBankAccountNumber }}</b>
        <b> ({{ data?.businessName }})</b> den
        <b>{{ data?.insertTime ? format(new Date(data.insertTime), 'dd.MM.yyyy') : '-' }}</b> fra
        kontonummer
        <b>{{ data?.fromBankAccountNumber }}</b>
        <Button
          @click.prevent.stop="print"
          class="p-2 rounded-sm w-full m-0 cursor-pointer flex-1 justify-start hover:bg-slate-100"
          variant="ghost"
        >
          Last ned utbetalingsbilag
        </Button>
      </DialogDescription> -->
      <PaymentVoucherContent :payoutId="payoutId" />
    </DialogContent>
  </Dialog>
</template>
